import { useQuery } from '@tanstack/react-query';
import { Info, TriangleAlert, X } from 'lucide-react';
import { useState } from 'react';
import { api } from '../api/client.js';
import { dismissNotice, isNoticeDismissed, noticeKey } from '../lib/maintenance.js';

const FIVE_MINUTES = 5 * 60_000;

/**
 * A slim banner above every screen, signed in or out, while staff have set a maintenance message
 * (GET /v1/notice, docs/adr/0024). It fetches after the first paint, refreshes every five minutes, and
 * renders nothing while loading, on error, or once dismissed for this session.
 */
export function MaintenanceBanner() {
  const notice = useQuery({ queryKey: ['notice'], queryFn: () => api('notice'), staleTime: 60_000, refetchInterval: FIVE_MINUTES, retry: false });
  const [dismissed, setDismissed] = useState<string | null>(null);
  const m = notice.data?.maintenance;
  if (!m || dismissed === noticeKey(m) || isNoticeDismissed(m)) return null;
  const Icon = m.level === 'warning' ? TriangleAlert : Info;
  return (
    <div className={`maint-banner maint-${m.level}`} role="status">
      <Icon size={16} aria-hidden="true" className="maint-icon" />
      <p className="maint-text">{m.message}</p>
      <button
        type="button"
        className="maint-close"
        aria-label="Dismiss this notice"
        onClick={() => {
          dismissNotice(m);
          setDismissed(noticeKey(m));
        }}
      >
        <X size={16} aria-hidden="true" />
      </button>
    </div>
  );
}
